/**
  * Image Block
  *
  * @package SSV Reutlingen
  */
/**
 * Internal dependencies.
 */
import Edit from './edit';

/**
 * WordPress Dependencies.
 */ 
import { registerBlockType } from '@wordpress/blocks';
import { InnerBlocks, useBlockProps } from '@wordpress/block-editor';
import { image } from '@wordpress/icons'; 
import { __ } from '@wordpress/i18n';

/**
 * Register block type.
 */
	registerBlockType( 'ssvreutlingen-blocks/image', {

		apiVersion: 2,
	/**
	 * Block title.
	 *
	 * @type {string}
	 */
	title: __( 'SSV Bild', 'ssvreutlingen' ),

	/**
	 * Block icon.
	 *
	 * @type {string}
	 */
	icon: image,

	supports: {
		anchor: true,
		align: ['center','wide'], 
	},
	attributes: {
		align: {
			type: 'string',
			default: 'center'
		}
	},
	
	 /**
	  * Block description.
	  *
	  * @type {string}
	  */
	 description: __( 'Bild Element für mittlere und volle Breite.', 'ssvreutlingen' ),
 
	 /**
	  * Block category.
	  *
	  * @type {string}
	  */
	 category: 'ssvreutlingen',

	 edit: Edit,

 
	 /**
	  * Save function.
	  *
	  * @param {Object} props                    Props
	  *
	  * @param          props.attributes
	  * @param          props.attributes.content
	  * @return {Object} Content.
	  */
	  save( { attributes } ) {
		const {
			align
		} = attributes;	
		const blockProps = useBlockProps.save();
		var checkAlign = JSON.stringify( { align } );
		const isCenter = checkAlign.includes('center');
		const classAlign = isCenter ? 'page__content -middleimage' : 'page__content -fullwidthimage';
		 return (

			<div  { ...blockProps } className={ classAlign }>
				<div className='page__content-image-figure-wrap'>
				<InnerBlocks.Content />
				</div>
			</div>
			

		);
	 },
 } );
 